"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderRadiusL = exports.BorderRadiusM = exports.BorderRadiusS = exports.BorderRadiusNone = exports.BorderThickL = exports.BorderThickM = exports.BorderThickS = exports.BorderDarkHc = exports.BorderDark = exports.BorderLightHc = exports.BorderLight = void 0;
exports.BorderLight = "1px solid #a4b1b8";
exports.BorderLightHc = "1px solid #6b7882";
exports.BorderDark = "1px solid #8a97a0";
exports.BorderDarkHc = "1px solid #bbc7cd";
exports.BorderThickS = "1px";
exports.BorderThickM = "2px";
exports.BorderThickL = "4px";
exports.BorderRadiusNone = "0px";
exports.BorderRadiusS = "3px";
exports.BorderRadiusM = "4px";
exports.BorderRadiusL = "8px";
